// 自定义事件留存
import request from "@/utils/request"; //事件列表

export function customEventList(data) {
  return request({
    url: "/data/customEventList",
    method: "get",
    params: data
  });
} // 新增

export function customEventAdd(data) {
  return request({
    url: '/data/customEventAdd',
    method: 'post',
    params: data
  });
} // 修改

export function customEventUpd(data) {
  return request({
    url: '/data/customEventUpd',
    method: 'post',
    params: data
  });
} // 删除

export function customEventDel(data) {
  return request({
    url: '/data/customEventDel',
    method: 'post',
    params: data
  });
} //事件列表

export function customPlayerList(data) {
  return request({
    url: "/data/customPlayerList",
    method: "get",
    params: data
  });
} // 新增

export function customPlayerAdd(data) {
  return request({
    url: '/data/customPlayerAdd',
    method: 'post',
    params: data
  });
} // 修改

export function customPlayerUpd(data) {
  return request({
    url: '/data/customPlayerUpd',
    method: 'post',
    params: data
  });
} // 删除

export function customPlayerDel(data) {
  return request({
    url: '/data/customPlayerDel',
    method: 'post',
    params: data
  });
}